import { REQUIRED } from '@atlassian/jira-issue-create-common-types/src/common/constants/index.tsx';
import type { SelectOption } from '@atlassian/jira-issue-field-organizations/src/index.tsx';
import type { FieldValue, JiraCustomerServiceOrganizationFieldInput } from './types.tsx';

export const mapOrganizationOptionToData = (option: SelectOption): number =>
	Number.parseInt(option.value, 10);

// TODO either use this for retainUserInputTransform or remove it
export const mutateOrganizationField = (
	selectedOrganization: FieldValue,
	fieldId: string,
): JiraCustomerServiceOrganizationFieldInput => ({
	organizationField: {
		fieldId,
		organization: {
			organizationId: selectedOrganization.value,
		},
	},
});

export const validateOrganizationField = (
	value: SelectOption | undefined,
	isRequired: boolean,
): string | undefined => {
	if (isRequired) {
		if (!value) {
			return REQUIRED;
		}
	}
	return undefined;
};
